import React from "react";
import Button from '@mui/material/Button';
import { ValidateTestMethodAdminFuncInput } from "./ValidateTestMethodAdminFuncInput";
const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  testMethod,
  navigate,
  _testMethodExist,
  _createErrorMessage,
  _deleteTestMethod,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/TestMethodOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationTestMethodResult = ValidateTestMethodAdminFuncInput(
      testMethod,
      _createErrorMessage
    );

    if (!validationTestMethodResult) {
      return;
    }

    _testMethodExist({ data: { Id: testMethod } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("107");
        return;
      }
      _deleteTestMethod({ data: { Id: testMethod } });

    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
